"use strict";

export const CURRENCY_LABEL = 'RON';

export function initMultilineEllipsis() {
    $('.clamp, [data-clamp]').each((index, el) => {
        const lines = $(el).attr('data-clamp') || 'auto';
        $clamp(el, {clamp: lines});
    });
}

export function initRangeSliders() {
    const sliders = jQuery('[data-range-slider]');
    sliders.each((index, slider) => {
        const id = slider.getAttribute('id');
        const name = slider.getAttribute('data-range-slider');
        const min = +slider.getAttribute('data-range-slider-min');
        const max = +slider.getAttribute('data-range-slider-max');
        const step = +slider.getAttribute('data-range-slider-step') || 1;
        const selected = slider.getAttribute('data-range-slider-selected') || '';
        let units = slider.getAttribute('data-range-slider-units') || '';
        if (units) {
            units = ' ' + units;
        }
        const decimals = slider.getAttribute('data-range-slider-decimals') || 0;
        const fixedTooltips = slider.getAttribute('data-range-slider-fixed-tooltips') === 'true';
        const start = /^(?<prefix>[^\d-]*)\s*(?<min>-?\d+)(?:\s*-\s*)(?<max>-?\d+)\s*(?<suffix>\D*)$/.exec(selected);

        const valueMin = +start.groups.min;
        const valueMax = +start.groups.max;

        const config = {
            start: [valueMin || min, valueMax || max],
            connect: true,
            range: {
                ...(
                    valueMin < min ? {
                        'min': [valueMin, min - valueMin],
                        '10%': [min],
                    } : {
                        'min': [min]
                    }
                ),
                ...(
                    valueMax > max ? {
                        '90%': [max, valueMax - max],
                        'max': [valueMax],
                    } : {
                        'max': [max],
                    }
                ),
            },
            tooltips: [
                wNumb({
                    decimals,
                    suffix: units
                }),
                wNumb({
                    decimals,
                    suffix: units
                })
            ],
            format: wNumb({
                decimals,
            }),
            step,
            handleAttributes: [
                { 'aria-label': 'lower' },
                { 'aria-label': 'upper' },
            ],
        };

        jQuery(slider).addClass('range-slider');
        jQuery(slider.parentElement)
            .append(`<input type="number" name="${name}min" min="${config.range['min'][0]}" max="${config.range['max'][0]}" step="${step}" id="${id}-min" style="display: none;">`)
            .append(`<input type="number" name="${name}max" min="${config.range['min'][0]}" max="${config.range['max'][0]}" step="${step}" id="${id}-max" style="display: none;">`)
            .append(`<input type="text" id="${id}-selected" style="display: none;">`)
            .append(`<button class="range-slider__apply-range" style="display: none;">APLICA</button>`);

        const applyRangeButton = jQuery(slider.parentElement).find('.range-slider__apply-range');

        noUiSlider.create(slider, config);

        const onSliderChange = (values) => {
            if (window.matchMedia("(min-width: 768px)").matches) {
                applyRangeButton.slideDown();
            } else {
                applySliderValues(values);
            }
        };

        const applySliderValues = (values) => {
            const minEl = jQuery(`#${id}-min`);
            const minValueAsMin = minEl.siblings('[data-range-slider]').attr('data-range-slider-min') === values[0];
            const maxEl = jQuery(`#${id}-max`);
            const maxValueAsMax = maxEl.siblings('[data-range-slider]').attr('data-range-slider-max') === values[1];
            minEl.val(minValueAsMin && maxValueAsMax ? '' : values[0]);
            maxEl.val(minValueAsMin && maxValueAsMax ? '' : values[1]);
            jQuery(`#${id}-selected`).val(minValueAsMin && maxValueAsMax ? '' : `${values.join('-')}${units}`).trigger('change');
            applyRangeButton.slideUp();
        };

        applyRangeButton.on('click', function(){
            applySliderValues(slider.noUiSlider.get());
        });

        applySliderValues(slider.noUiSlider.get());

        slider.noUiSlider.on('change', onSliderChange);
        slider.noUiSlider.on('set', onSliderChange);

        // jQuery(slider.parentElement).find(`#${id}-min`).on('change', function () {
            // slider.noUiSlider.set([this.value, null]);
        // });

        // jQuery(slider.parentElement).find(`#${id}-max`).on('change', function () {
            // slider.noUiSlider.set([null, this.value]);
        // });

        if (fixedTooltips) {
            jQuery(slider.parentElement).prepend(`
                <div class="range-slider__fixed-tooltip-container">
                    <div class="range-slider__fixed-tooltip range-slider__fixed-tooltip--min">${start.groups.min}${units}</div> 
                    <div class="range-slider__fixed-tooltip range-slider__fixed-tooltip--max">${start.groups.max}${units}</div> 
                </div>
            `);
            slider.noUiSlider.on('update', function (values, handle) {
                jQuery(slider.parentElement).find(`.range-slider__fixed-tooltip--min`).html(values[0] + units);
                jQuery(slider.parentElement).find(`.range-slider__fixed-tooltip--max`).html(values[1] + units);
            });
        }
    })
}

export function indeterminateCheckboxes(){
    let checked = $(this).prop("checked"),
        container = $(this).parent(),
        siblings = container.siblings();

    container.find('input[type="checkbox"]').prop({
        indeterminate: false,
        checked: checked
    });

    function checkSiblings(el) {
        let parent = el.parent().parent(),
            all = true;
        el.siblings().each(function() {
            let returnValue = all = ($(this).children('input[type="checkbox"]').prop("checked") === checked);
            return returnValue;
        });

        if (all && checked) {
            parent.children('input[type="checkbox"]').prop({
                indeterminate: false,
                checked: checked
            });
            checkSiblings(parent);
        } else if (all && !checked) {
            parent.children('input[type="checkbox"]').prop("checked", checked);
            parent.children('input[type="checkbox"]').prop("indeterminate", (parent.find('input[type="checkbox"]:checked').length > 0));
            checkSiblings(parent);
        } else {
            el.parents("li").children('input[type="checkbox"]').prop({
                indeterminate: true,
                checked: false
            });
        }
    }
    checkSiblings(container);
}

export function initSimpleZoom() {
    $('.simple-zoom').zoom();
}

export function openTab(e, id, group) {
    e?.preventDefault();
    const tabId = id || $(this).attr('data-open-tab');
    const tabGroupName = group || $(this).attr('data-tab-group');
    if (tabGroupName) {
        $(`[data-tab-group="${tabGroupName}"]`)
            .removeClass('active')
            .filter(`[data-open-tab="${tabId}"], [data-tab="${tabId}"]`)
            .addClass('active');
    } else {
        $(this)
            .parent()
            .find(`[data-open-tab], [data-tab]`)
            .removeClass('active')
            .filter(`[data-open-tab="${tabId}"], [data-tab="${tabId}"]`)
            .addClass('active');
    }

}

/**
 *
 * @param e: Click Event
 * @param id?: Modal ID to open (other-vice will take from element data attribute)
 * @param type?: Static or normal
 */
export function openModalDialog(e, id, type) {
    e?.preventDefault();
    const modalId = id || $(this).attr('data-open-modal');
    const modal = $('#'+modalId);
    if (modalId && modal.length) {
        modal.addClass('active');
        if (type) {
            modal.toggleClass('modal--static', type === 'static');
        }
        if (type !== 'static') {
            const body = $('body');
            document.documentElement.style.setProperty('--body-width-for-modal', `${body.innerWidth()}px`);
            body.addClass('modal-opened');
            $('jdiv').first().hide(); // hide jivo chat
        }
        document.dispatchEvent(new CustomEvent("modalDialog", {
            detail: {
                eventType: 'open',
                id: modalId,
                modalType: type,
            }
        }));
    } else {
        console.warn(`Modal with id: ${modalId} wasn't found`);
    }
}

/**
 *
 * @param e: Click Event
 * @param id?: Modal ID to switch (other-vice will take from element data attribute)
 * @param tyoe?: Static or normal
 */
export function switchModalDialog(e, id, type) {
    e?.preventDefault();
    closeModalDialog.call(this);
    const modalId = id || $(this).attr('data-switch-modal');
    const modalType = type || $(this).attr('data-switch-modal-type');
    document.dispatchEvent(new CustomEvent("modalDialog", {
        detail: {
            eventType: 'switch',
            id: modalId,
            modalType,
        }
    }));
    openModalDialog(e, modalId, modalType);
}

export function autoOpenModal() {
    $('[data-auto-open-modal]').each((index, item) => {
        const modalId = $(item).attr('data-auto-open-modal') || $(item).attr('id');
        let type;
        const remoteTrigger = !$(item).hasClass('modal');
        if (remoteTrigger) {
            type = $(item).attr('data-auto-open-modal-type');
        }
        document.dispatchEvent(new CustomEvent("modalDialog", {
            detail: {
                eventType: 'autoOpen',
                id: modalId,
                modalType: type,
            }
        }));
        openModalDialog(undefined, modalId, type);
    });
}

/**
 *
 * @param e: Click Event
 * @param id?: Modal ID to close (other-vice will take from element data attribute)
 */
export function closeModalDialog(e, id) {
    e?.preventDefault();
    if (id) {
        $(`#${id}.modal`).removeClass('active');
        document.dispatchEvent(new CustomEvent("modalDialog", {
            detail: {
                eventType: 'close',
                id
            }
        }));
    } else {
        if (this) {
            $(this).closest('.modal').removeClass('active');
            document.dispatchEvent(new CustomEvent("modalDialog", {
                detail: {
                    eventType: 'close',
                    id: $(this).closest('.modal').attr('id')
                }
            }));
        } else {
            closeAllModalDialogs();
        }
    }
    if (!$('.modal.active').not('.modal--static').length) {
        $('body').removeClass('modal-opened');
        $('jdiv').first().show(); // show jivo chat
    }
}

export function closeAllModalDialogs() {
    $('.modal').removeClass('active');
    $('body').removeClass('modal-opened');
    document.dispatchEvent(new CustomEvent("modalDialog", {
        detail: {
            eventType: 'closeAll',
        }
    }));
    $('jdiv').first().show(); // hide jivo chat
}

/**
 * Check if specific or any modal dialog is open
 * @param name
 * @returns {boolean}
 */
export function isModalOpen(name) {
    if (name) {
        return !!$(`.modal.${name}.active`).length;
    } else {
        return !!$(`.modal.active`).length;
    }
}

export function togglePasswordInputPreview() {
    const input = $(this).next();
    if (input.attr('type') === 'password') {
        input.attr('type', 'text');
        $(this).removeClass('skl-icon-hide').addClass('skl-icon-show');
    } else {
        input.attr('type', 'password');
        $(this).removeClass('skl-icon-show').addClass('skl-icon-hide');
    }
}

/**
 *
 * @param size: number
 * @param minmax: 'min' | 'max'
 * @returns {boolean}
 */
export function matchResponsiveSize(size, minmax = 'min') {
    if (minmax === 'max') {
        size = size - 0.02;
    }
    return matchMediaQuery(`(${minmax}-width: ${size}px)`);
}

export function matchMediaQuery(query) {
    return window.matchMedia(query).matches;
}


const appHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
}
export function lazyVideo() {
    if ("IntersectionObserver" in window) {
        const videoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.target.hasAttribute("lazy")) {
                    if (!entry.target.poster && entry.dataset?.poster) {
                        entry.target.poster = entry.dataset.poster;
                    }
                    for (let source in entry.target.children) {
                        let videoSource = entry.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }
                    entry.target.load();
                    entry.target.removeAttribute("lazy");
                    videoObserver.unobserve(entry.target);
                }
            });
        }, {
            root: null,
            rootMargin: '100px',
            threshold: 0,
        });

        document.querySelectorAll("video[lazy]").forEach(function (video) {
            videoObserver.observe(video);
        });
    }
}

export function autoplayVideoInViewport() {
    if ("IntersectionObserver" in window) {
        const videoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.target.hasAttribute('autoplay-video-in-viewport')) {
                    if (entry.target.readyState === 4) {
                        entry.target.play();
                    }
                }
            });
        }, {
            threshold: 0.9
        });

        document.querySelectorAll("video[autoplay-video-in-viewport]").forEach(function (video) {
            videoObserver.observe(video);
        });
    }
}

export function copyToClipboard(e, text) {
    e?.preventDefault();
    if (!window.isSecureContext) {
        console.warn('Copy to clipboard requires a secure connection');
        return;
    }
    const value = text || $(this).attr('data-copy-to-clipboard');
    if (value) {
        navigator.clipboard.writeText(value);
    }
}

export default function init(){
    document.documentElement.classList.remove("no-js");

    window.currencyLabel = CURRENCY_LABEL;

    initMultilineEllipsis();
    initRangeSliders();
    initSimpleZoom();
    lazyVideo();
    autoplayVideoInViewport();
    $('ul ul input[type="checkbox"]').each((index, item) => indeterminateCheckboxes.call(item));
    $('input[type="checkbox"]').change(indeterminateCheckboxes);

    autoOpenModal();

    const body = $('body');

    body
        .on('click', '.modal .modal__close', closeModalDialog)
        .on('click', '[data-open-modal]', openModalDialog)
        .on('click', '[data-switch-modal]', switchModalDialog)
        .on('click', '[data-close-modal]', closeModalDialog)
        .on('click', '[data-copy-to-clipboard]', copyToClipboard);

    body.on('click', '[data-open-tab]', openTab);

    body.on('click', '.toggle-password', togglePasswordInputPreview);

    window.addEventListener('resize', appHeight);
    appHeight();
}
